import React from "react";
import "./currentGuest.scss";
import CurrentGuestTableForm from "../../../components/CurrentGuestTableForm/CurrentGuestTableForm";

const Currentguest = () => {
  return (
    <div className="current-guest-containor">
      <CurrentGuestTableForm />
    </div>
  );
};

export default Currentguest;
